<template>
  <!-- Page Header -->
  <div class="page-header">
    <div class="row align-items-center">
      <div class="col-1 mr-n5">
        <a @click="$router.back()">
          <i class="fa-solid fa-circle-arrow-left fa-2x"></i>
        </a>
      </div>
      <div class="col-auto">
        <h3 class="page-title">{{ title }}</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <!-- <router-link to="/admin-dashboard"> -->
            {{ path }}
            <!-- </router-link> -->
          </li>
          <li class="breadcrumb-item active">{{ text }}</li>
        </ul>
      </div>
    </div>
  </div>
  <!-- /Page Header -->
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
